import type {DataValue, VerifiedLinkedAgentLink} from '../types';
import {isLinkedAgentLink} from './isLinkedAgentLink';

export const isVerifiedLinkedAgentLink = (
  value: DataValue | undefined,
): value is VerifiedLinkedAgentLink => {
  return isLinkedAgentLink(value) && value.linkStatus === 'verified';
};
